export default __webpack_public_path__ + "virtualdj.00d1d5a5.png";